import React, { useState } from 'react';
import { Data } from './Data';
import styled from 'styled-components';
import { IconContext } from 'react-icons';
import { FiChevronUp, FiChevronDown } from 'react-icons/fi';
import './Faqs.scss';

const AccordionSection = styled.div`
  background: #fff;
`;

const Container = styled.div`
  box-shadow: 2px 10px 35px 1px rgba(153 153 153, 0.3);
  padding-bottom: 20px;
  background-color: #f3f3f3;
  border-radius: 12px;
`;

const Wrap = styled.div`
  background: #f6f6f6;
  color: #21212b;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  justify-content: space-between;

  position: relative;
  align-items: center;
  width: 100%;
  cursor: pointer;
  h1 {
    margin-top: 20px;
    margin-left: 12px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
  }

  span {
    margin-top: 20px;
    margin-right: 1.5rem;
    float: right;
  }
`;

const Dropdown = styled.div`
  background: #f6f6f6;
  padding-top: 12px;
  padding-left: 12px;
  padding-bottom: 20px;

  p {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #20202a;
  }
`;

const Faqs = () => {
  const [clicked, setClicked] = useState(false);
  const toggle = (index) => {
    if (clicked === index) {
      //if clicked question s already active, then close it
      return setClicked(null);
    }
    setClicked(index);
  };
  return (
    <div className="question-container">
      <p className="question-container__title">
        На случай, если <br /> остались вопросы
      </p>
      <IconContext.Provider value={{ color: '#F2244B', size: '24px' }}>
        <AccordionSection>
          <Container>
            {Data.map((item, index) => {
              return (
                <>
                  <div className="wrap-container">
                    <Wrap onClick={() => toggle(index)} key={index}>
                      <h1>{item.question}</h1>
                      <span>
                        {clicked === index ? (
                          <FiChevronDown />
                        ) : (
                          <FiChevronUp />
                        )}
                      </span>
                    </Wrap>
                    {clicked === index ? null : (
                      <Dropdown>
                        <p>{item.answer}</p>
                      </Dropdown>
                    )}
                  </div>
                </>
              );
            })}
          </Container>
        </AccordionSection>
      </IconContext.Provider>
    </div>
  );
};

export default Faqs;
